export enum ERIS_Screen {
  Login = 'login',
  AuthCallback = 'auth-callback',
  History = 'history',
  Main = 'main',
}
